var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import * as propertyActions from "@rentiohq/shared-frontend/dist/reduxV2/property/property.actions";
import * as propertySelectors from "@rentiohq/shared-frontend/dist/reduxV2/property/property.selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { PropertySelect } from "../../../index";
import { Loading } from "../../../Loading/Loading.styled";
import { ELoadingSize } from "../../../Loading/Loading.types";
export var FormPropertySelect = function (props) {
    var formData = props.formData, onSelectProperty = props.onSelectProperty, onRemoveProperty = props.onRemoveProperty, disabled = props.disabled, _a = props.isMultiSelect, isMultiSelect = _a === void 0 ? false : _a, customPropertyFilter = props.customPropertyFilter, rest = __rest(props, ["formData", "onSelectProperty", "onRemoveProperty", "disabled", "isMultiSelect", "customPropertyFilter"]);
    var dispatch = useDispatch();
    var query = {
        page: 1,
        limit: CONFIG.DEFAULT_FETCH_LIMIT,
        filter: {
            id: { in: isMultiSelect ? formData : [formData] },
        },
    };
    var _b = useSelector(function (state) {
        return propertySelectors.getPaged(state, query);
    }) || {}, properties = _b.items, isFetching = _b.isFetching;
    React.useEffect(function () {
        if (formData) {
            dispatch(propertyActions.getPagedStart.getAction({
                query: query,
            }));
        }
    }, [formData]);
    var handlePropertyAdd = function (property) {
        return onSelectProperty(property.id);
    };
    var handlePropertyRemove = function (removedProperty) {
        return onRemoveProperty(removedProperty === null || removedProperty === void 0 ? void 0 : removedProperty.id);
    };
    if (isFetching)
        return _jsx(Loading, { size: ELoadingSize.Large });
    var maxItems = isMultiSelect ? undefined : 1;
    return (_jsx(PropertySelect, __assign({ onPropertyAdd: handlePropertyAdd, onPropertyRemove: handlePropertyRemove, showPropertyList: true, properties: properties, maxItems: maxItems, disabled: disabled, customFilter: customPropertyFilter, label: rest.title }, rest)));
};
